const OrganisationSettingsComponents = {
    ORGANISATION_SETTINGS: "organisationSettings",
};

export default OrganisationSettingsComponents;
